import React from 'react';
import PropTypes from 'prop-types';
import { DateField, getDateValidation, GridItem } from '../../common';

const BIRTHDAY = 'birthday';

function BirthdayField({ paths, required, setFieldValue, values }) {
  return (
    <GridItem sm={6} xs={12}>
      <DateField
        fieldName={BIRTHDAY}
        label="Birth Date"
        paths={paths}
        required={required}
        setFieldValue={setFieldValue}
        values={values}
      />
    </GridItem>
  );
}

BirthdayField.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  paths: PropTypes.array,
  required: PropTypes.bool,
};

const defaultRequired = false;

BirthdayField.defaultProps = {
  paths: [],
  required: defaultRequired,
};

export default BirthdayField;

export function getBirthdayValidation(config = {}) {
  return getDateValidation({
    ...config,
    fieldName: BIRTHDAY,
    label: 'Birth Date',
  });
}



// WEBPACK FOOTER //
// ./src/modules/ChildInformationPage/components/BirthdayField.js